
function RiskManual() {    

    return (
            <div className='layer_overlay' style={{overflowY:'auto', overflowX:'none'}}>
                <div>
                <center>
                    <table border='0' cellPadding='0'>
                        <tr><td>risk</td></tr>
                    </table>
                </center>
                </div>
            </div>
    );
}

export default RiskManual;